import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
import { listStateSystem } from './listStateSystem';
import { loggerSystem, LogLevel } from './loggerSystem';
import { sizeSystem } from './sizeSystem';
import { stateFlagsSystem, UP } from './stateFlagsSystem';
/**
 * Fixes upward scrolling by calculating and compensation from changed item heights, using scrollBy.
 */
export var upwardScrollFixSystem = u.system(function (_a) {
    var _b = __read(_a, 5), _c = _b[0], scrollBy = _c.scrollBy, scrollTop = _c.scrollTop, deviation = _c.deviation, scrollingInProgress = _c.scrollingInProgress, _d = _b[1], isScrolling = _d.isScrolling, isAtBottom = _d.isAtBottom, atBottomState = _d.atBottomState, scrollDirection = _d.scrollDirection, lastJumpDueToItemResize = _d.lastJumpDueToItemResize, listState = _b[2].listState, _e = _b[3], beforeUnshiftWith = _e.beforeUnshiftWith, shiftWithOffset = _e.shiftWithOffset, sizes = _e.sizes, log = _b[4].log;
    var deviationOffset = u.streamFromEmitter(u.pipe(listState, u.withLatestFrom(lastJumpDueToItemResize), u.scan(function (_a, _b) {
        var _c = __read(_a, 4), prevItems = _c[1], prevTotalCount = _c[2], prevTotalHeight = _c[3];
        var _d = __read(_b, 2), 
        // @ts-ignore
        _e = _d[0], items = _e.items, totalCount = _e.totalCount, bottom = _e.bottom, offsetBottom = _e.offsetBottom, lastJumpDueToItemResize = _d[1];
        var totalHeight = bottom + offsetBottom;
        var newDev = 0;
        if (prevTotalCount === totalCount) {
            if (prevItems.length > 0 && items.length > 0) {
                var atStart = items[0].originalIndex === 0 &&
                    prevItems[0].originalIndex === 0;
                if (!atStart) {
                    newDev = totalHeight - prevTotalHeight;
                    if (newDev !== 0) {
                        newDev += lastJumpDueToItemResize;
                    }
                }
            }
        }
        return [newDev, items, totalCount, totalHeight];
    }, [0, [], 0, 0]), u.filter(function (_a) {
        var _b = __read(_a, 1), amount = _b[0];
        return amount !== 0;
    }), u.withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, log, isAtBottom, atBottomState), u.filter(function (_a) {
        var _b = __read(_a, 4), scrollTop = _b[1], scrollDirection = _b[2], scrollingInProgress = _b[3];
        // console.log({ amount, scrollTop, scrollDirection, scrollingInProgress, isAtBottom, atBottomState })
        return (!scrollingInProgress && scrollTop !== 0 && scrollDirection === UP); // && (isAtBottom ? amount > 0 : true)
    }), u.map(function (_a) {
        var _b = __read(_a, 5), _c = __read(_b[0], 1), amount = _c[0], log = _b[4];
        log('Upward scrolling compensation', { amount: amount }, LogLevel.DEBUG);
        return amount;
    })));
    u.connect(u.pipe(deviationOffset, u.withLatestFrom(deviation), u.map(function (_a) {
        var _b = __read(_a, 2), amount = _b[0], deviation = _b[1];
        return deviation - amount;
    })), deviation);
    // when the browser stops scrolling,
    // restore the position and reset the glitching
    u.subscribe(u.pipe(u.combineLatest(u.statefulStreamFromEmitter(isScrolling, false), deviation), u.filter(function (_a) {
        var _b = __read(_a, 2), is = _b[0], deviation = _b[1];
        return !is && deviation !== 0;
    }), u.map(function (_a) {
        var _b = __read(_a, 2), deviation = _b[1];
        return deviation;
    }), u.throttleTime(1)), function (offset) {
        if (offset > 0) {
            u.publish(scrollBy, { top: -offset, behavior: 'auto' });
            u.publish(deviation, 0);
        }
        else {
            u.publish(deviation, 0);
            u.publish(scrollBy, { top: -offset, behavior: 'auto' });
        }
    });
    u.connect(u.pipe(shiftWithOffset, u.map(function (offset) {
        return { top: -offset };
    })), scrollBy);
    u.connect(u.pipe(beforeUnshiftWith, u.withLatestFrom(sizes), u.map(function (_a) {
        var _b = __read(_a, 2), offset = _b[0], lastSize = _b[1].lastSize;
        return offset * lastSize;
    })), deviationOffset);
    return { deviation: deviation };
}, u.tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem));
